<template>
    <v-container fluid>
        <v-row justify="center" class="ma-0">
            <v-card style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
                <v-card-title>
                    <v-row class="ma-0">
                        <span>Análise de Mortalidade Por Causas</span>
                    </v-row>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-container fluid>
                        <!-- Filtros -->
                        <v-row>
                            <mortality-causes-filters @apply="listMortalityCauses" @removeComparativos="removerTodosGraficos"/>
                        </v-row>
                        <!-- <v-row v-if="!listDataGraph.length" justify="center" >
                            <v-alert border="left" color="primary" elevation="4" icon="fa-exclamation-triangle" outlined type="error">
                                Não foi possível encontrar lotes com essas características. Selecione novamente os filtros desejados.
                            </v-alert>
                        </v-row> -->
                        <v-row v-for="(dataGraph, idx) in listDataGraph" :key="idx">
                            <v-col cols="2" xl="2">
                                <v-subheader>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    depressed
                                                    icon
                                                    x-small
                                                    color="#ff5252"
                                                    @click.native="removerGrafico(idx)"
                                                    class="mr-2 card-actions__btn delete"
                                            >
                                                <v-icon x-small color="white">fas fa-trash</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remover comparativo</span>
                                    </v-tooltip>
                                    Filtros
                                </v-subheader>
                                <div>
                                    <v-container class="py-0">
                                        <v-row align="center" justify="start">
                                            <v-col v-for="(selection) in dataGraph.listDataFilters" :key="selection.text" class="shrink" style="padding: 3px;">
                                                <v-chip>
                                                    {{ selection.text }}
                                                </v-chip>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </v-col>
                            <v-col cols="5" xl="5">
                                <!-- Chart -->
                                <v-subheader>Gráfico</v-subheader>                                
                                <mortality-causes-graph :values="dataGraph.listDataMortalidade" />
                            </v-col>
                            <v-col cols="5" xl="5">
                                <!-- Table -->
                                <v-subheader>Tabela</v-subheader>
                                <mortality-causes-table :loading="loading" :table-data="dataGraph.listDataMortalidade"
                                                        :totalMortalidade="dataGraph.totalMortalidade" @apply="applyLotesFilter" />
                            </v-col>
                            <v-col v-if="dsMotivoBaixaFilter != ''" cols="12" xl="12">
                                <!-- Table Lotes -->
                                <v-subheader>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    depressed
                                                    icon
                                                    x-small
                                                    color="#ff5252"
                                                    @click.native="removerTabelaLotes()"
                                                    class="mr-2 card-actions__btn delete"
                                            >
                                                <v-icon x-small color="white">fas fa-trash</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remover tabela</span>
                                    </v-tooltip>
                                    Lotes de Produção com mortes por "{{dsMotivoBaixaFilter}}"
                                </v-subheader>
                                <lotes-causes-table :loading="loading" :dataGraph="dataGraph" :dsMotivoBaixaFilter="dsMotivoBaixaFilter" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
            <AppLoaderBlockCard :overlay="loading"/>
        </v-row>
    </v-container>
</template>

<script>
import {URLS} from '@/modules/MortalityCauses/api/urls';
import MortalityCausesFilters from '@/modules/MortalityCauses/components/MortalityCausesFilters';
import MortalityCausesGraph from "@/modules/MortalityCauses/components/MortalityCausesGraph";
import MortalityCausesTable from "@/modules/MortalityCauses/components/MortalityCausesTable";
import LotesCausesTable from "@/modules/MortalityCauses/components/LotesCausesTable";
import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'
import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'

export default {
    name: 'MortalityCauses',
    components: {MortalityCausesTable, MortalityCausesGraph, MortalityCausesFilters, AppLoaderBlockCard, LotesCausesTable},
    data: () => ({
        listDataGraph: [],
        loading: false,
        dsMotivoBaixaFilter: ''
    }),
    computed: {
        uepTypes() {
            return [
                {csTipoUep: 'CR', dsTipoUep: 'Creche'},
                {csTipoUep: 'TR', dsTipoUep: 'Terminação'},
                {csTipoUep: 'WF', dsTipoUep: 'Wean to Finish'},
                {csTipoUep: 'UP', dsTipoUep: 'UPL'}
            ];
        },
        statusTypes() {
            return [
                {csStatus: 'AB', dsStatus: 'Aberto'},
                {csStatus: 'FE', dsStatus: 'Fechado'}
            ];
        },
        genderTypes() {
            return [
                {sgSexo: 'MA', dsSexo: 'Macho'},
                {sgSexo: 'FE', dsSexo: 'Fêmea'},
                {sgSexo: 'MI', dsSexo: 'Misto'}
            ];
        },
        weekTypes() {
            return [
                {nrSemana: 1, dsSemana: 'Semana 1'},
                {nrSemana: 2, dsSemana: 'Semana 2'},
                {nrSemana: 3, dsSemana: 'Semana 3'},
                {nrSemana: 4, dsSemana: 'Semana 4'},
                {nrSemana: 5, dsSemana: 'Semana 5'},
                {nrSemana: 6, dsSemana: 'Semana 6'},
                {nrSemana: 7, dsSemana: 'Semana 7'},
                {nrSemana: 8, dsSemana: 'Semana 8'},
                {nrSemana: 9, dsSemana: 'Semana 9'},
                {nrSemana: 10, dsSemana: 'Semana 10'},
                {nrSemana: 11, dsSemana: 'Semana 11'},
                {nrSemana: 12, dsSemana: 'Semana 12'},
                {nrSemana: 13, dsSemana: 'Semana 13'},
                {nrSemana: 14, dsSemana: 'Semana 14'},
                {nrSemana: 15, dsSemana: 'Semana 15'},
                {nrSemana: 16, dsSemana: 'Semana 16'},
                {nrSemana: 17, dsSemana: 'Semana 17'},
                {nrSemana: 18, dsSemana: 'Semana 18'},
                {nrSemana: 19, dsSemana: 'Semana 19'},
                {nrSemana: 20, dsSemana: 'Semana 20'},
                {nrSemana: 21, dsSemana: 'Semana 21'}
            ];
        },
    },
    methods: {
        dateLocalToIso,
        dateIsoToLocal,
        removerTabelaLotes() {
            this.dsMotivoBaixaFilter = ''
        },
        removerTodosGraficos() {
            this.listDataGraph = []
            this.dsMotivoBaixaFilter = ''
        },
        removerGrafico(index) {
            this.listDataGraph.splice(index, 1);
        },
        async listMortalityCauses(queryParams = null, listaUepOrigem = null, technicalManagers = null, tiposComedouro = null, tiposBebedouro = null, tiposPiso = null) {
            this.loading = true;
            this.totalMortalidade = 0;

            const response = await this.$axios
                .get(URLS.MORTALITY_CAUSES, {
                    params: queryParams
                })
                .finally(() => (this.loading = false));

            if (response.status === 200) {
                if (response.data.length > 0) {
                    const data = response.data[0].data.data;
                    const listLotes = response.data[0].data.lotes
                    if (data) this.toDataMortalidade(data, listLotes, queryParams, listaUepOrigem, technicalManagers, tiposComedouro, tiposBebedouro, tiposPiso);
                    else this.$store.commit('setSnack', {type: 'error', msg : 'Não foi possível encontrar lotes com essas características!'});
                }
            }
        },
        toDataMortalidade(data, lotes, filterParams, listaUepOrigem, technicalManagers, tiposComedouro, tiposBebedouro, tiposPiso) {
            let totalMortalidade = data.reduce((acc, next) => {return acc + next.quantidade}, 0);

            let dataMortalidade = data.map((entry) => ({
                dsMotivo: entry.motivo != null ? entry.motivo : 'Não Informado',
                nrQuantidade: entry.quantidade,
                peMortalidade: (entry.quantidade * 100 / totalMortalidade).toFixed(2) + '%'
            }));

            let dataFilter = []
            if (filterParams == null) {
                let itemFilter = {
                    text: 'Nenhum Filtro selecionado'
                }
                dataFilter.push(itemFilter)
            }
            else {
                for (var key in filterParams) {
                    let texto = ''
                    if (key == 'dtInicio') {
                        texto = 'Mortalidade de: ' + dateIsoToLocal(filterParams[key])
                    }
                    else if (key == 'dtFim') {
                        texto = 'Mortalidade até: ' + dateIsoToLocal(filterParams[key])
                    }
                    else if (key == 'dtInicioAlojamento') {
                        var dataArray = filterParams[key].split('-')
                        texto = 'Alojados em: ' + dataArray[1] + '/' + dataArray[0]
                    }
                    else if (key == 'dtFimAlojamento') {
                        continue
                    }
                    else if (key == 'dtInicioFechamento') {
                        var dataArray = filterParams[key].split('-')
                        texto = 'Finalizados em: ' + dataArray[1] + '/' + dataArray[0]
                    }
                    else if (key == 'dtFimFechamento') {
                        continue
                    }
                    else if (key == 'csTipoUep') {
                        texto = 'Tipo UEP: ' + this.uepTypes.find(x => x.csTipoUep === filterParams[key]).dsTipoUep
                    }
                    else if (key == 'cdUepOrigem') {
                        texto = 'Origem: ' + listaUepOrigem.find(x => x.idUnidadeExploracao == filterParams[key]).displayText
                    }
                    else if (key == 'cdResponsavelTecnico') {
                        texto = 'Extensionista: ' + technicalManagers.find(x => x.idResponsavelTecnico == filterParams[key]).nmPessoa
                    }
                    else if (key == 'sgSexo') {
                        texto = 'Gênero dos animais: ' + this.genderTypes.find(x => x.sgSexo === filterParams[key]).dsSexo
                    }
                    else if (key == 'flAberto') {
                        let value = filterParams[key] ? 'AB' : 'FE'
                        texto = 'Status do lote: ' + this.statusTypes.find(x => x.csStatus === value).dsStatus
                    }
                    else if (key == 'cdTipoComedouro') {
                        texto = 'Comedouro: ' + tiposComedouro.find(x => x.idTipoComedouro === filterParams[key]).nmTipoComedouro
                    }
                    else if (key == 'cdTipoBebedouro') {
                        texto = 'Bebedouro: ' + tiposBebedouro.find(x => x.idTipoBebedouro === filterParams[key]).nmTipoBebedouro
                    }
                    else if (key == 'cdTipoPiso') {
                        texto = 'Piso: ' + tiposPiso.find(x => x.idTipoPiso === filterParams[key]).nmTipoPiso
                    }
                    else if (key == 'nrSemana') {
                        texto = 'Semana: ' + this.weekTypes.find(x => x.nrSemana === filterParams[key]).dsSemana
                    }
                    else {
                        continue
                    }

                    let itemFilter = {
                        text: texto
                    }
                    dataFilter.push(itemFilter)
                }
            }

            let sortedDataMortalidade = dataMortalidade.sort(
                (a, b) => b.nrQuantidade - a.nrQuantidade
            );

            let newData = {
                totalMortalidade: totalMortalidade,
                listDataMortalidade: sortedDataMortalidade,
                listDataFilters: dataFilter,
                listLotes: lotes
            }
            this.listDataGraph.push(newData)
        },
        applyLotesFilter(dsMotivoBaixa) {
            this.dsMotivoBaixaFilter = dsMotivoBaixa
        },
    },
    mounted() {
        // this.listMortalityCauses();
    }
};
</script>

